// Parts carry two prices: part_cost (what the company paid — internal, never printed)
// and sell_price (what the customer is charged). Both share the tax basis of
// jobs.invoice_total (gross for tax-inclusive tenants, net otherwise).
//
// The default sell price is cost + the company's parts_markup_pct, unless the catalog
// part carries a fixed default_sell_price. The same formula lives in the DB trigger
// job_parts_default_sell_price() for rows inserted without a sell price (tech app).

export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function effectiveSellPrice(
  cost: number | null | undefined,
  overrideSell: number | null | undefined,
  markupPct: number | null | undefined,
): number {
  if (overrideSell != null) return round2(overrideSell);
  return round2((cost ?? 0) * (1 + (markupPct ?? 0) / 100));
}

export function partsCostTotal(parts: { part_cost: number; quantity: number }[]): number {
  return round2(parts.reduce((sum, p) => sum + p.part_cost * p.quantity, 0));
}

export function partsSellTotal(parts: { sell_price: number; quantity: number }[]): number {
  return round2(parts.reduce((sum, p) => sum + p.sell_price * p.quantity, 0));
}

export function partsMargin(parts: { part_cost: number; sell_price: number; quantity: number }[]): number {
  return round2(partsSellTotal(parts) - partsCostTotal(parts));
}
